export default {
  INIT_CONFIGURATION: {
    checkLoginIframe: false,
    enableLogging: true,
    onLoad: 'login-required'
  },
  KEYCLOAK_CONFIGURATION: {
    'realm': 'master',
    'url': window.KEYCLOAK_AUTH_URL,
    'ssl-required': 'external',
    'clientId': window.KEYCLOAK_AUTH_CLIENT_ID,
    'public-client': true,
    'confidential-port': 0
  }
};